.root {
  display: grid;
  grid-template-columns: auto min-content;
  background-color: var(--accountSidebarBg);
  border-left: 1px solid var(--accountSidebarInnerBorderColor);
  color-scheme: dark;
}

.audioElContainer {
  line-height: 0;
}
.audioElContainer audio {
  width: 100%;
}
.audioElContainer audio::-webkit-media-controls-enclosure {
  border-radius: 0;
  background: transparent;
}
.audioElContainer audio::-webkit-media-controls-panel {
  padding-right: 0;
}

.closeButton {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  text-align: inherit;
  border-radius: 9999999px;
  padding: 0.5rem;
  line-height: 0;
  align-self: center;
}
.closeButton .closeButtonIcon {
  vertical-align: middle;
  background-color: var(--accountSidebarIconColor);
}

.rootCustom {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.5rem 0.5rem 0.5rem 0.75rem;
  color: var(--accountSidebarIconColor);
}

.senderLine {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  text-align: inherit;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  text-align: start;
  cursor: pointer;
}

.senderText {
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.2;
}

.senderName,
.chatName {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.senderName {
  font-weight: 600;
  font-size: 0.9em;
}

.chatName {
  font-size: 0.8em;
  opacity: 0.8;
}

.strip {
  position: absolute;
  top: var(--navBarHeight);
  inset-inline: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  background-color: var(--bgPrimary);
  color: var(--textPrimary);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.stripRow {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  height: 36px;
  padding-inline: 0.25rem;
}

.stripPlayButton {
  padding-inline: 13px;
}

.stripLabel {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  text-align: inherit;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: start;
  font-size: 0.85em;
  cursor: pointer;
}

.stripSpacer {
  flex: 1;
}

.speedPill {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  text-align: inherit;
  border: 1px solid currentColor;
  border-radius: 9999999px;
  padding: 0.1rem 0.5rem;
  font-size: 0.85em;
  line-height: 1.2;
}

.hairline {
  height: 2px;
  background-color: var(--separatorColor, rgba(143, 153, 168, 0.3));
}

.hairlineFill {
  height: 100%;
  background-color: var(--colorPrimary);
}

.controlsRow {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  min-width: 0;
}
.controlsRow > :first-child {
  flex: 1;
  min-width: 0;
}